import {registerTemplateGraphNode} from "#template/template-node/register"
import {meshGeometryAttributeLike, meshGeometryAttributeLikeMarker} from "#template/nodes/geometry-graph/attribute/attribute-node"
import type {MeshGeometryAttributeLikeNode} from "#template/nodes/geometry-graph/attribute/attribute-node"

import type {TemplateNodeDefinition} from "#template/template-node/types"
import {getTemplateNodeReturns} from "#template/template-node/validation"

import type {CastOperatorParameters} from "#template/nodes/geometry-graph/attribute/cast-operator/geometry-cast-operator-node"
import {GeometryCastOperatorNode, castOperatorParametersSchema} from "#template/nodes/geometry-graph/attribute/cast-operator/geometry-cast-operator-node"

export type MeshGeometryCastOperatorParameters = CastOperatorParameters<MeshGeometryAttributeLikeNode>

const definition: TemplateNodeDefinition<MeshGeometryCastOperatorParameters> = {
    nodeClass: "MeshGeometryCastOperator",
    validation: {
        parameters: castOperatorParametersSchema(meshGeometryAttributeLike),
        returns: getTemplateNodeReturns(),
    },
}

@registerTemplateGraphNode
export class MeshGeometryCastOperator extends GeometryCastOperatorNode<2, MeshGeometryAttributeLikeNode> implements MeshGeometryAttributeLikeNode {
    get [meshGeometryAttributeLikeMarker]() {
        return true as const
    }

    public override get definition() {
        return definition
    }
}
